/*
 * View for a single campaign
 */

define(["marionette", "./template/campaignInfoTemplate.html"], function (
  Marionette,
  CampaignInfoTemplate,
) {
  const CampaignInfoView = {};

  CampaignInfoView.campaignInfoView = Marionette.ItemView.extend({
    template: CampaignInfoTemplate,
    triggers: {
      "click #deleteNewCampaign": "delete:new:campaign",
    },
    textboxes: {
      "#campaignNameText": {
        enableSelector: "#campaignNameText",
        modelAttribute: "name",
        placeholder: "admin.campaigns.campaign.name",
        textArea: false,
      },
      "#campaignDescription": {
        enableSelector: "#campaignDescription",
        modelAttribute: "description",
        placeholder: "admin.campaigns.campaign.description",
        textArea: false,
      },
    },
  });

  return CampaignInfoView;
});
